module.exports = __webpack_public_path__ + "img/hover-ring.17afff61.svg";